import styled from 'styled-components';
import { ReactComponent as IconVulnerability_ } from 'Images/vulnerabilities.svg';
import { ReactComponent as EmptyFolder_ } from 'Images/empty-folder.svg';
import { ReactComponent as GoTo } from 'Images/icon-goto.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 34px;
  width: 94%;
  min-width: 0;
`;
Wrapper.displayName = 'Wrapper';

export const LeftCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden; 
`;

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto; /* se va al final */
  flex: 0 0 auto;
`;

export const InputTitle = styled.input`
  margin: 0;
  padding-right: 10px;

  flex: 0 1 auto;
  width: auto;
  min-width: 100px;
  max-width: 100%;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.detailModalTitle};
  border: none;
  cursor: pointer;
  border-radius: 5px;
  background-color: transparent;

  &:focus {
    cursor: text;
    color: ${({ theme }) => theme.text.detailNameHover};
    outline: none;
    flex: 1 1 auto; 
    text-overflow: clip;
  }

  &:not(:focus) {
    &:hover {
      color: ${({ theme }) => theme.text.detailNameHover};
      background-color: ${({ theme }) => theme.textfield.background};
    }
  }
`;
InputTitle.displayName = 'InputTitle';

export const DuplicateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 25px;
  border-radius: 6px;
  background-color: #bec8d2;
  padding: 3px 8px;
  margin-right: 10px;
`;
DuplicateWrapper.displayName = 'DuplicateWrapper';

export const IconVulnerability = styled(IconVulnerability_)`
  margin-right: 11px !important;
  path {
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke-width: 0.5;
  }
`;
IconVulnerability.displayName = 'IconVulnerability_';

export const GoToButton = styled.div`
  width: 38px;
  cursor: pointer;
  border-radius: 20px;
  &:hover {
    background-color: #dfe5ed;
  }
`;
GoToButton.displayName = 'GoToButton';

export const GoToIcon = styled(GoTo)`
  path:not([d="M0 0h38v38H0z"]) {
    fill: ${({ theme }) => theme.icons.actionBar.color} !important;
  }
`;
GoToIcon.displayName = 'GoToIcon';

export const EmptyFolderIcon = styled(EmptyFolder_)`
  margin-right: 11px !important;
  height: 20px;
  width: 20px;

  & path { fill: ${({ theme }) => theme.icons.detailModalTitle.color}; }
  & g path { fill: ${({ theme }) => theme.icons.detailModalTitle.color}; }
  & * { stroke: ${({ theme }) => theme.icons.detailModalTitle.color}; }
`;
EmptyFolderIcon.displayName = 'EmptyFolderIcon';
